import { handleResponse } from '../../helpers/handleResponse';
import authHeader from '../../helpers/authHeader';

// const user = JSON.parse(localStorage.getItem("user"));
// const author = user && user !== "undefined" ? user.userObj.id : "";

const API_URL = process.env.REACT_APP_API_URL;

const getStandardCode = () => {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
        credentials: 'include'
    };
    return fetch(API_URL + `/standard/`, requestOptions).then(handleResponse);
};

const getStandardCodeWithPagination = queryString => {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
        credentials: 'include'
    };
    return fetch(API_URL + `/standard/${queryString}`, requestOptions).then(handleResponse);
};

export default {
    getStandardCode,
    getStandardCodeWithPagination
}